module.exports = __webpack_public_path__ + "Titillium-Semibold.335fa19d71acfc48aa9a.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Titillium-Semibold.otf
// module id = 378
// module chunks = 8